import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import EmployeeDashboard from "@/pages/EmployeeDashboard";
import OfferteAccept from "@/pages/OfferteAccept";

function LoginGate() {
    const { user, loading } = useAuth();
    if (loading) return <div className="min-h-screen flex items-center justify-center text-[#64748B]">Laden…</div>;
    if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/employee"} replace />;
    return <Login />;
}

function App() {
    return (
        <div className="App">
            <LanguageProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/offerte/:id" element={<OfferteAccept />} />
                            <Route path="/login" element={<LoginGate />} />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute role="admin">
                                        <AdminDashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/employee"
                                element={
                                    <ProtectedRoute role="employee">
                                        <EmployeeDashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                        <Toaster position="top-right" richColors closeButton />
                    </BrowserRouter>
                </AuthProvider>
            </LanguageProvider>
        </div>
    );
}

export default App;
